import {
  Component,
  Input,
  OnChanges,
  OnInit,
  Output,
} from 'angular-ts-decorators';
import { faRedo } from '@fortawesome/pro-solid-svg-icons';

/**
 * Component that manages initializing all of the services in the app
 *
 * # Temporary approach
 *
 * # Final API
 * <pre>
 *   <sw-app-loader dependencies="{settings, session}"></sw-app-loader>
 * </pre>
 */
@Component({
  selector: 'swAppLoader',
  template: require('./sw-app-loader.html').default,
  transclude: true,
})
export class SwAppLoaderComponent implements OnInit, OnChanges {
  @Input() promise: ng.IPromise<any>;
  @Output() retry: () => any;

  public isDebugCollapsed: boolean;
  public faRedo = faRedo;
  public state: 'pending' | 'resolved' | 'rejected';
  public error: any;

  ngOnInit() {
    this.isDebugCollapsed = true;
  }

  ngOnChanges(changes: any) {
    if (changes && changes.promise && changes.promise.currentValue) {
      this.state = 'pending';
      this.error = undefined;

      this.promise
        .then(() => (this.state = 'resolved'))
        .catch((error) => {
          this.state = 'rejected';

          if (angular.isString(error)) {
            this.error = error;
          }
        });
    }
  }

  toggleDebug() {
    this.isDebugCollapsed = !this.isDebugCollapsed;
  }
}
